import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { Input, } from '../input';
import { Row, Col } from '../grid';
import { StyledErrorLabel } from '../input/style';

const options = {
  placeholder: '',
  style: {
    base: {
      color: '#333',
      lineHeight: '30px',
      fontWeight: '600',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '16px',
      '::placeholder': {
        color: '#d2c8c6',
      },
    },
    invalid: {
      color: '#333'
    }
  }
}

const expiryOptions = { ...options, placeholder: 'MM / AA' }

export const StripeFields = ({ errors, setFieldError }) => {
  const handleChange = (element, fieldName) => {
    if(element.error){  
      setFieldError(fieldName, element.error.message);
    }
    else {
      setFieldError(fieldName, '');
    }
  }

  const StripeErrorMessage = ({ message }) => {
    if(message){
      return(
        <StyledErrorLabel>
          {message}
        </StyledErrorLabel>
      )
    }
    else return null;
  }

  return (
    <>
      <Input name="creditCardNumber" includeError="false" label="Número do cartão de crédito">
        <CardNumberElement id="card-number-element" options={options} onChange={(e) => handleChange(e, 'creditCardNumber')} />
        <StripeErrorMessage message={errors.creditCardNumber} />
      </Input>

      <Input
        name="creditCardHolderName"
        label="Nome impresso no cartão"
      />

      <Row>
        <Col>
          <Input name="creditCardExpiry" includeError="false" label="Expiração">
            <CardExpiryElement id="card-expiry-element" options={expiryOptions} onChange={(e) => handleChange(e, 'creditCardExpiry')} />
            <StripeErrorMessage message={errors.creditCardExpiry} />
          </Input>
        </Col>

        <Col>
          <Input name="creditCardCvc" includeError="false" label="CVC">
            <CardCvcElement id="card-cvc-element" options={options} onChange={(e) => handleChange(e, 'creditCardCvc')} />
            <StripeErrorMessage message={errors.creditCardCvc} />
          </Input>
        </Col>
      </Row>
    </>
  )
}

export default StripeFields;
